import { PricingSheetRow } from '../../../../../shared/types';
import { ValueGetterParams } from 'ag-grid-community';

const catClassValueGetter = (
  params: ValueGetterParams<PricingSheetRow>,
) => {
  if (!params.data) return null;
  const { catClass, pimDisplayName, name } = params.data;
  const displayName = pimDisplayName ? pimDisplayName : name;
  return `${catClass} ${displayName}`;
};

export default catClassValueGetter;
